<template>
  <div class="hello">

  <div class="page-top" style="position: relative;">

    <span class="title">
      <h2>Welcome</h2>
    </span>
  </div>
  <!--/ page-top-->
  <section class="section intro" style="background-color: #222;">
    <div class="row">
      <div class="col s12 m6">
        <div class="card">

  <ad-featured></ad-featured>

        </div>
      </div>

      <div class="col s12 m6">
        <div class="card" style="height: 375px !important;">
          <iframe title="Legal Description" src="https://player.vimeo.com/video/202127989" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        </div>
      </div>
    </div>

  </section>
  <nav class="teal quote-runner">
    <div class="nav-wrapper">
      <p>Join the local movement!</p>
    </div>
  </nav>


  </div>

</template>

<script>

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (max-width: 680px) {
  .home-page-title {
    font-size: 15vw !important;
  }
}

 :root {
  --page-color: #2196f3;
}

html,
body {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.cat-box {
  margin: 1em 1em;
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
}

featured-scroll {
  display: none;
}

.cat-box-low {
  height: 100%;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.cat-box-low p {
  padding: 0 1em 1em 0;
}

.tab-content {
  height: auto;
  font-size: 1.3em!important;
  padding: 1em !important;
  justify-content: center;
}

.indicator {
  background-color: #fff !important;
}

.tabs .tab a {
  color: #333 !important;
}
</style>
